/* Enord Core classic v1.0 — Cards slider arrows */
(function(){
  function init(root){
    if(root.__ecc)return;root.__ecc=1;
    var tr=root.querySelector('[data-ecc-track]'),pv=root.querySelector('[data-ecc-prev]'),nx=root.querySelector('[data-ecc-next]');
    if(!tr)return;
    function step(){var s=tr.querySelector('.ecc-slide');return s?s.getBoundingClientRect().width:tr.clientWidth}
    function sync(){var max=tr.scrollWidth-tr.clientWidth-2;
      if(pv)pv.style.visibility=tr.scrollLeft<=2?'hidden':'visible';
      if(nx)nx.style.visibility=tr.scrollLeft>=max?'hidden':'visible'}
    var tm;tr.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(sync,40)},{passive:true});
    if(pv)pv.addEventListener('click',function(){tr.scrollBy({left:-step(),behavior:'smooth'})});
    if(nx)nx.addEventListener('click',function(){tr.scrollBy({left:step(),behavior:'smooth'})});
    window.addEventListener('resize',sync);sync();
  }
  function all(){document.querySelectorAll('[data-ecc]').forEach(init)}
  all();document.addEventListener('shopify:section:load',all);
})();
